export const REASONS_TO_BOOK = [
  {
    image: "/images/social-proof-world.png",
    title: "We know adventure",
    details: [
      "Founded by experienced travellers, active and adventure vacations are all we do.",
      "Experience the trip of a lifetime organized by a team of travel specialists who combine knowledge and passion for adventure travel.",
    ],
  },
  {
    image: "/images/social-proof-compass.png",
    title: "Self-guided specialists",
    details: [
      "With over 600 tours across 30+ countries, we specialize in self-guided tours.",
      "Combine the freedom of travelling on your own with the confidence that all of your logistics are taken care of.",
    ],
  },
  {
    image: "/images/social-proof-list.png",
    title: "Packed with value",
    details: [
      "Get everything you need for your next vacation with one easy booking.",
      "We take care of accommodations, luggage transfers, gear rentals, and more - so you can focus on making memories.",
    ],
  },
  {
    image: "/images/badge.png",
    title: "World Class support",
    details: [
      "Get unbeatable support at every step of your journey.",
      "Whether you are planning or travelling, no matter what your question, a real human is always a call or click away.",
    ],
  },
  {
    image: "/images/cocktail.png",
    title: "Hassle free bookings",
    details: [
      "Have peace of mind for when travel plans change.",
      "Explore our flexible booking, payment, and cancellation options, as well as our Lifetime Deposits program.",
    ],
  },
]
